import { Colors, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

export const ValuesAlignmentCard = ({ percentage }: { percentage: number | null }) => {
    const { t } = useAmelioTranslations();
    const clampedValue = percentage === null ? 0 : Math.max(0, Math.min(100, percentage));

    return (
        <div
            className={
                'border-primary/20 from-primary/5 flex min-h-[80px] w-full flex-col gap-[8px] rounded-[8px] border bg-gradient-to-br to-blue-50 p-[16px] sm:min-h-24 md:min-h-28'
            }
        >
            <div className={'flex items-center gap-[6px]'}>
                <Icon
                    name={'essential-tick-circle'}
                    size={16}
                    color={Colors.PRIMARY_400}
                />
                <Text
                    size={'small'}
                    weight={'semibold'}
                    className={'text-[12px] tracking-wide uppercase'}
                >
                    {t('postReviewResults.valuesAlignment')}
                </Text>
            </div>
            <div className={'flex items-center gap-3'}>
                {percentage === null ? (
                    <Text
                        size={'large'}
                        weight={'semibold'}
                        className={'text-gradient-teal-blue-purple flex-shrink-0 text-[24px]'}
                    >
                        {t('postReviewResults.valuesAlignmentNotAvailable')}
                    </Text>
                ) : (
                    <div
                        className={'flex w-full items-end gap-[8px]'}
                        role={'progressbar'}
                        aria-valuenow={clampedValue}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        aria-label={`${clampedValue}% complete`}
                    >
                        <Text
                            size={'large'}
                            weight={'semibold'}
                            className={'text-gradient-teal-blue-purple flex-shrink-0 text-[24px]'}
                        >
                            {`${clampedValue}%`}
                        </Text>

                        {/* The rail and its fill only draw the measure the wrapper above announces:
                            a second progressbar role here would make screen readers count it twice. */}
                        <div
                            aria-hidden={'true'}
                            className={'h-[6px] w-full overflow-hidden rounded-full bg-gray-200'}
                        >
                            <div
                                className={
                                    'bg-gradient-teal-blue-purple h-full rounded-full shadow-lg'
                                }
                                style={{
                                    width: `${clampedValue}%`,
                                    transition: 'width 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                data-testid={'step-progress-bar'}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
